import React from 'react';
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";
import { getCurrentLangName } from "helpers/String.helper";

const PostWritingPopup = (props: any) => {
    const {
        onClose,
        content,
        subject,
        initSubject,
        images,
        onContentChange,
        onSubjectChange,
        onRemoveImage,
        onImageUpload,
        onPost,
        isPosting,
        fileInputRef,
        myPostCount
    } = props;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4">
            <div className="bg-white rounded-2xl p-6 w-full max-w-md mx-auto">
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-2">
                        <svg className="w-6 h-6 text-[#CF3688]/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                        <h3 className="text-lg font-bold text-gray-900">
                            {getLanguageValue(PAGE_TYPE.STUDENT, "hubCommunity.txtPostWriteTitle")}
                        </h3>
                    </div>

                    <button className="text-gray-400 hover:text-gray-600" onClick={onClose}>
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="space-y-3">
                    {myPostCount === 0 &&
                        <div className="bg-[#FFD700] p-4 rounded-2xl shadow-sm mb-4">
                            <div className="flex items-center space-x-3">
                                <div className="rounded-full flex items-center justify-center flex-shrink-0">
                                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-700">
                                        {getLanguageValue(PAGE_TYPE.STUDENT, "home.txtNoticeWritePost")}
                                    </p>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="space-y-4">
                        <textarea
                            className="w-full h-32 px-4 py-2 border-2 border-gray-200 rounded-xl
                                                     focus:!border-[#CF3688] 
                                                    text-base transition-colors resize-none"
                            placeholder={getLanguageValue(PAGE_TYPE.STUDENT, "hubCommunity.txtPostWritePlaceholder")}
                            maxLength={1000}
                            value={content}
                            onChange={onContentChange}
                        />
                        <div className="mb-4 flex items-center gap-2">
                            <p className="text-sm text-gray-500 whitespace-nowrap">
                                {getLanguageValue(PAGE_TYPE.STUDENT, "hubCommunity.txtSubjectTitle")}
                            </p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" className="inline-block ml-1">
                                <path d="M9 18l6-6-6-6" />
                            </svg>
                            {initSubject ?
                                <div className="text-md text-[#cf3688] font-bold whitespace-nowrap">
                                    {initSubject}
                                </div>
                                :
                                <input type="text" className="w-full px-4 py-2 border-2 border-gray-200 rounded-xl focus:!border-[#CF3688] text-base transition-colors"
                                    placeholder={getLanguageValue(PAGE_TYPE.STUDENT, "hubCommunity.txtSubjectPlaceholder")}
                                    maxLength={100}
                                    value={subject}
                                    onChange={onSubjectChange}
                                />
                            }
                        </div>
                        {/* 이미지 미리보기 영역 */}
                        {images.length > 0 && (
                            <div className="relative">
                                <div className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide space-x-3">
                                    {images.map((image: any) => (
                                        <div key={image.id} className="flex-none w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 relative snap-center rounded-xl overflow-hidden">
                                            <img src={image.url} alt="" className="w-full h-full object-cover" />
                                            <button
                                                onClick={() => onRemoveImage(image.id)}
                                                className="absolute top-0 right-0 p-1.5 bg-[#cf3688]/70 rounded-full text-white ">
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                                </svg>
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div className="flex justify-between items-center">
                            <div className="flex space-x-2">
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    className="hidden"
                                    accept=".png,.jpg,.jpeg,image/png,image/jpg,image/jpeg"
                                    multiple
                                    onChange={onImageUpload}
                                    disabled={isPosting}
                                />
                                <button
                                    onClick={() => fileInputRef.current?.click()}
                                    disabled={isPosting || images.length >= 10}
                                    className={`p-2 transition-colors ${isPosting || images.length >= 10
                                        ? 'text-gray-400 cursor-not-allowed'
                                        : 'text-gray-500 hover:text-[#CF3688]'
                                        }`}
                                    title={`이미지 추가 (${images.length}/10)`}>
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                </button>

                                <div className="flex items-center gap-2 text-sm text-gray-500">
                                    <span>{images.length}/10</span>
                                </div>
                            </div>

                            <button
                                onClick={onPost}
                                disabled={isPosting}
                                className="px-4 py-2 rounded-xl bg-[#CF3688] text-white hover:bg-[#B32E74] transition-colors
                                        focus:outline-none focus:ring-2 focus:ring-[#CF3688]/20">
                                {getLanguageValue(PAGE_TYPE.STUDENT, "hubCommunity.btnWrite")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PostWritingPopup;